module.exports = __webpack_public_path__ + "img/about_bk.f49343ed.png";